import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class BackLinkComponent extends Component {
  @service session;
}
